export const setAction = (type, payload) => {
    return { type, payload }
}
